<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="form-group">
      <label class="label-form">Followup Date {{date}}</label>
      <input class="form-control" v-model="followup_date" type="datetime-local" /> {{getFollowUpHistory}}
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary text-light btn-sm" data-dismiss="modal">
        Close
      </button>
      <button type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-success text-light btn-sm ml-1" @click="save">
          <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
          Save
      </button>
      <!--  -->
       <table class="table table-bordered table-hover" style="margin-top: 10px; text-align: center;">
          <th>Follow Up History</th>
          <th>Updated Date</th>

        <tbody v-if="follow_up_history.length>0">
        
          <tr  class="mt-2" v-for="(history, index) in follow_up_history" :key="history.id">
            <td>
              <div class="form-check">
                <!-- <input type="checkbox" class="form-check-input" v-if="demo.completed == 1" checked disabled /> -->
                <!-- <input type="checkbox" class="form-check-input" v-else value="" id="" disabled /> -->
                <label class="form-check-label font-weight-bold">
                  {{ history.full_name}}
                </label>
              </div>
            </td>
            <td class="text-start">{{history.updated_value | formatDate }}</td>
          </tr>
           
        </tbody>
        <tbody v-else>
         <tr class="mt-2">
            <td class="text-center" colspan="2">Follow Up History Not Found</td>
          </tr>
        </tbody>
      </table>
      <!--  -->
    </div>  
  </form>
</template>

<script>
  import axios from "axios";
  import moment from "moment";
    Vue.filter("formatDate", function (value) {
    if ( value != null) {
      return moment(String(value)).format("DD MMM, Y");
    }
  });
  export default {
    props: ["action", "formData", "pageNumber", "status"],
    data: function () {
      return {
        followup_date: "",
        isMiniLoading : false,
        follow_up_history:'',
      };
    },
    computed: {
          date: function () {
            this.followup_date = moment(String(this.formData.followup_date)).format('YYYY-MM-DDThh:mm')
          },
       getFollowUpHistory: function () {

            const permission = {
          headers: {
            'X-Permission': 'lead_followup_date_history' 
          }
        };
        axios
          .get("/admin/users/get-followup-history/" + this.formData.user,permission)
          .then((response) => {
            let data = response.data.followup_history;

            if (data != null) {
              this.follow_up_history = data;
            }else{
              this.follow_up_history = '';
            }

          });
      },

    },
    methods: {
      save() {
        this.isMiniLoading = true;
        let demo_id = this.formData.user;
        let page_no = this.formData.pageNumber;
        let self = this;
        let followup_date = self.followup_date;
        if (followup_date != null && followup_date != "") {
          const permission = {
      headers: {
        'X-Permission': 'lead_set_followup_date' 
      }
    };
          axios
            .post("/admin/users/change-followup-date", {
              date: followup_date,
              id: demo_id,
            },permission)
            .then(() => {
              this.isMiniLoading = false;
              this.$toast.success("Followup Date has been Updated successfully");
              window.$("#modal").modal("hide");
              this.followup_date = "";
              this.$store.dispatch("users/getAllDemoRequests", [page_no,"",this.formData.status, "", "", "","","","",this.formData.color ? this.formData.color : "", this.formData.followup_filter,'all','all' ]);
            })
            .catch((error) => {
              this.isMiniLoading = false;
              this.$toast.error(error);
            });  
        } else {
          this.isMiniLoading = false;
          this.$toast.warning("Please Fill All Required Fields");
        }
      },
    },
  };
</script>
<style scoped>

input {
    position: relative;
}

input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 18% !important;
    right: 2%;
    width: auto;
}
</style>